<div
  class="row"
  *ngIf="offer"
>
  <div class="col-8 border-right pe-5">
    <div class="row mt-4">
      <p class="col-5 fw-bold">{{ 'operations.hourlyRating' | translate }}</p>
      <p class="col-7">{{ offer.hourlyRate | baseFormatDecimal }} €</p>
    </div>
    <div class="row mb-4">
      <p class="col-5 fw-bold">{{ 'surcharges.cancellationPeriod' | translate }}</p>
      <p class="col-7">
        {{ offer.cancelationPeriod | baseIsEmpty }}
        <ng-container *ngIf="offer.cancelationPeriod">{{ 'relativeTime.hours' | translate }}</ng-container>
      </p>
    </div>
    <base-expansion-panel
      *ngIf="offer?.industrySurcharges"
      title="industrySurcharges.plural"
      titleClass="headline-24"
      class="d-block mb-4"
    >
      <base-industry-surcharges [surcharges]="offer.industrySurcharges!"></base-industry-surcharges>
    </base-expansion-panel>
    <div class="mb-4">
      <h5>{{ 'surcharges.plural' | translate }}</h5>
      <p class="fw-bold">{{ 'accordingToSpecification' | translate }}</p>
      <base-surcharges [surcharges]="offer.surcharges || []"></base-surcharges>
    </div>
  </div>

  <div class="col-4 location-info ps-5">
    <div class="my-4">
      <h5>{{ 'operations.assignmentLocation' | translate }}</h5>
      <span class="fw-medium">{{ inquiry ? inquiry?.customerLocation?.name : offer.location.name }}</span
      ><br />
      {{ inquiry ? inquiry?.customerDepartment?.name : offer.department.name }}<br />
      {{ inquiry ? inquiry?.customerDepartment?.businessAddress.street : offer.department.businessAddress.street
      }}<br />
      {{ inquiry ? inquiry?.customerDepartment?.businessAddress.postCode : offer.department.businessAddress.postCode }}
      {{ inquiry ? inquiry?.customerDepartment?.businessAddress.city : offer.department.businessAddress.city }}
    </div>

    <div class="my-4">
      <h5>{{ 'provider' | translate }}</h5>
      {{ offer.pspBranch.legalName }}<br />
      {{ offer.pspBranch.businessAddress?.street }}<br />
      {{ offer.pspBranch.businessAddress?.postCode }} {{ offer.pspBranch.businessAddress?.city }}<br />
      <div class="d-flex flex-row align-items-center gap-2 mt-2">
        <base-izs-rating
          [color]="offer.pspBranch.izsStatus"
          (click)="openIzsInfoModal($event)"
        ></base-izs-rating>
        <p class="m-0 fw-bold">{{ 'izs.rating' | translate }}</p>
      </div>
    </div>

    <p class="fw-bold mb-0 mt-2">{{ 'contactPerson' | translate }}</p>
    <p class="fw-bold mb-0 mt-2">{{ 'name' | translate }}</p>
    <span *ngIf="offer?.responsible">{{ offer.responsible?.firstName }} {{ offer.responsible?.lastName }}</span>
    <ng-container *ngIf="offer.responsible?.mobilePhone">
      <p class="fw-bold mb-0 mt-2">{{ 'externalEmployees.operationInfo.phone' | translate }}</p>
      <span>{{ offer.responsible?.mobilePhone }}</span>
    </ng-container>
    <ng-container *ngIf="offer.responsible?.email">
      <p class="fw-bold mb-0 mt-2">{{ 'externalEmployees.operationInfo.email' | translate }}</p>
      <span>{{ offer.responsible?.email }}</span>
    </ng-container>
  </div>
</div>
